import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `Analisis/sincronizarPendientesDataSwine`, method: 'POST', body: null, token: token})
}
